import { render, staticRenderFns } from "./PurchaseDeliveryLayout.vue?vue&type=template&id=23de47d7&scoped=true&"
import script from "./PurchaseDeliveryLayout.vue?vue&type=script&lang=js&"
export * from "./PurchaseDeliveryLayout.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseDeliveryLayout.vue?vue&type=style&index=0&id=23de47d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23de47d7",
  null
  
)

export default component.exports